import { Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildMySurveysDataTableFilter,
  useMySurveysDataTable,
} from 'generated/resources/datatable.graphql'
import { MySurveysDatatableTrainingsFilterFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type FilterOption = {
  label: string
  value: string
  component: JSX.Element
}
export const courseFilter = ({
  source,
  trainings,
}: {
  source: ReturnType<typeof useMySurveysDataTable>
  trainings: MySurveysDatatableTrainingsFilterFragment[]
}) => {
  const options: FilterOption[] =
    trainings.map((training) => ({
      label: training.name,
      value: training.id.toString(),
      component: <Text.Normal>{training.name}</Text.Normal>,
    })) ?? []

  return buildMySurveysDataTableFilter(source, {
    type: FilterType.String,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],

    identifier: 'courseFilter',
    path: 'trainingId',
    title: i18n.t('trainings.my_surveys.datatable.filters.course'),
  })
}
